import { useEngineModeSignal } from "../../../rx/signal/useEngineModeSignal"
import { useDraftMoveSignal } from "../../../rx/signal/useDraftMoveSignal"
import { freeze } from "../util/Object"
import type { Engine } from "./Engine.type"
import { EngineMode } from "./EngineMode/EngineMode.enum"
import { setEngineStateForTeardown } from "./setEngineState"

export default function garbageCollectEngine(engine: Engine): void {
  const [, setEngineMode] = useEngineModeSignal(engine)
  const [, setDraftMove] = useDraftMoveSignal(engine)
  setEngineMode(EngineMode.None)
  setDraftMove(null)
  setEngineStateForTeardown(engine, {
    ...engine.state,
    ents: [],
    online: null,
  })

  // might catch/prevent member leaks.
  engine.gcELL().forEach((fn) => fn())
  const ell = engine.ofELL()
  ell.length = 0
  freeze(ell)
  freeze(engine)
}
